import React, { Component }  from 'react';

export class PasswordItem extends Component {
  render() {
    return (
    <div>
      {this.props.value}
    </div>
    );
  }
}
